import api from "../../api";
import { getCorporateIdFromToken } from "@/utils/corporate";

export default {
  namespaced: true,
  state: {
    Facalities: [],
    FacalitiesAvailableForBusTypes: [],
    FacalitiesInBusType: [],
  },
  getters: {
    getFacalities(state) {
      return state.Facalities;
    },
    getFacalitiesAvailableForBusTypes(state) {
      return state.FacalitiesAvailableForBusTypes;
    },
    getFacalitiesInBusType(state) {
      return state.FacalitiesInBusType;
    },
  },
  mutations: {
    SetFacalities(state, data) {
      state.Facalities = [];
      state.Facalities = data;
    },
    SetFacalitiesAvailableForBusTypes(state, data) {
      state.FacalitiesAvailableForBusTypes = [];
      state.FacalitiesAvailableForBusTypes = data;
    },
    SetFacalitiesInBusType(state, data) {
      state.FacalitiesInBusType = [];
      state.FacalitiesInBusType = data;
    },
  },
  actions: {
    fetchAllFacalities({ commit }, data = {}) {
      return new Promise((resolve, rej) => {
        const corporateId = (data && (data.corporateId || data.CorporateId)) || getCorporateIdFromToken();
        const body = corporateId ? { corporateId } : {};
        api()
          .post("/facilities/get_all_facilities", body)
          .then((res) => {
            commit("SetFacalities", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    addFacality({}, Data) {
      return new Promise((resolve, rej) => {
        api()
          .post("/facilities/add_facility", Data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    update_facility({}, Data) {
      return new Promise((resolve, rej) => {
        api()
          .post("/facilities/update_facility", Data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    deleteFacality({}, Data) {
      return new Promise((resolve, rej) => {
        api()
          .post("/facilities/delete_facility", Data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    fetchFacalitiesAvailableForBusTypes({ commit }, busTypeId) {
      return new Promise((resolve, rej) => {
        api()
          .post(`/facilities/get_all_facilities_available_for_bus_type`, {
            busTypeId: busTypeId,
          })
          .then((res) => {
            commit("SetFacalitiesAvailableForBusTypes", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    fetchFacalitiesInBusType({ commit }, busTypeId) {
      return new Promise((resolve, rej) => {
        api()
          .post(`/facilities/get_facilities_of_bus_type`, {
            busTypeId: busTypeId,
          })
          .then((res) => {
            commit("SetFacalitiesInBusType", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    updateFacilityForBusType({}, Data) {
      return new Promise((resolve, rej) => {
        api()
          .post("/facilities/update_facility_for_bus_type", Data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
  },
};
